'use client'

import { useEffect, useState } from 'react'
import { UAParser } from 'ua-parser-js'

type DeviceType = 'mobile' | 'tablet' | 'desktop'

export function useDeviceType(): DeviceType {
  const [deviceType, setDeviceType] = useState<DeviceType>('desktop')

  useEffect(() => {
    const parser = new UAParser()
    const type = parser.getDevice().type as DeviceType | undefined
    setDeviceType(type || 'desktop')
  }, [])

  return deviceType
}

export function useIsMobileClient(): boolean {
  const deviceType = useDeviceType()
  return deviceType === 'mobile'
}

export function useIsTabletClient(): boolean {
  const deviceType = useDeviceType()
  return deviceType === 'tablet'
}

export function useIsDesktopClient(): boolean {
  const deviceType = useDeviceType()
  return deviceType === 'desktop'
}

export function useIsIOSClient(): boolean {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent)
}
